import axios from 'axios'
import { ChannelFormDto } from '../../../../_metronic/partials/widgets/ChannelForm'
import * as authHelper from '../../auth/core/AuthHelpers'
import { string } from 'yup'
import { IInformationPreferences, informationPreferences } from '../../accounts/components/settings/SettingsModel'
import { UsageAndSubcriptionDto } from '../../accounts/components/settings/cards/UsageAndSubscription'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/authanticate/verify_token`
export const LOGIN_URL = `${API_URL}/authanticate/login`
export const REGISTER_URL = `${API_URL}/authanticate/Signup`
export const REQUEST_PASSWORD_URL = `${API_URL}/authanticate/SendForgotPasswordEmail`
export const CheckAndRefreshTokenUrl = `${API_URL}/authanticate/CheckAndRefreshToken`
export const UpdateLanguageUrl = `${API_URL}/settings/UpdateLanguage`
export const ActivateAccountUrl = `${API_URL}/authanticate/ActivateAccount`
export const ActivateTeamMemberAccountUrl = `${API_URL}/authanticate/ActivateTeamMemberAccount`
export const FreezeAccountUrl = `${API_URL}/settings/FreezeAccount`
export const FreezeCompanyUrl = `${API_URL}/settings/FreezeCompany`
export const ResetPasswordUrl = `${API_URL}/authanticate/ResetPassword`
export const UpdatePasswordUrl = `${API_URL}/settings/UpdatePassword`
export const UpdateProfileUrl = `${API_URL}/settings/UpdateProfile`
export const UpdateProfileInformationPreferencesUrl = `${API_URL}/settings/UpdateProfileInformationPreferences`
export const GetProfileInformationPreferencesUrl = `${API_URL}/settings/GetProfileInformationPreferences`
export const UpdateCompanyUrl = `${API_URL}/settings/UpdateCompanyDetails`
export const AddOrUpdateChannelUrl = `${API_URL}/settings/AddOrUpdateChannel`
export const AddMultiChannelUrl = `${API_URL}/settings/AddMultiChannel`
export const DeleteChannelUrl = `${API_URL}/settings/DeleteChannel`
export const GetChannelListUrl = `${API_URL}/settings/GetChannelList`
export const AddFacebookIntegrationUrl = `${API_URL}/settings/FacebookLogin`
export const GetUsageAndSubcriptionUrl = `${API_URL}/settings/GetUsageAndSubcription`
export const GetCompanyQuickMessagesUrl = `${API_URL}/settings/GetCompanyQuickMessages`
export const UpdateCompanyQuickMessagesUrl = `${API_URL}/settings/UpdateCompanyQuickMessages`

export function login(email: string, password: string, isRememberMeChecked: boolean, deviceInfo: any) {

  let deviceInfoParsed = deviceInfo != null ? JSON.parse(deviceInfo) : null;
  let data = {
    'email': email,
    'password': password,
    'isRememberMeChecked': isRememberMeChecked,
    deviceInfo: deviceInfoParsed == null ? null : {
      ntoken: deviceInfoParsed?.ntoken,
      name: deviceInfoParsed?.name,
      type: deviceInfoParsed?.type,
      model: deviceInfoParsed?.model,
      brand: deviceInfoParsed?.brand,
      systemName: deviceInfoParsed?.systemName,
      systemVersion: deviceInfoParsed?.systemVersion
    }
  }
  // alert(JSON.stringify(data))

  return axios({
    method: 'post',
    url: LOGIN_URL,
    // url: 'https://api.aisenseus.net/api/Authanticate/Login',
    data: data
  });
}

export function updateProfile(nameSurname: string, language: string, timeZoneValue: string, timeZoneText: string, imageData: string) {

  return axios({
    method: 'post',
    url: UpdateProfileUrl,
    data: {
      'nameSurname': nameSurname,
      'timeZoneValue': timeZoneValue,
      'timeZoneText': "GMT" + timeZoneText,
      'language': language,
      'imageData': imageData,
    }
  });
}

export function getProfileInformationPreferences(): Promise<IInformationPreferences | undefined> {
  return axios
    .get(GetProfileInformationPreferencesUrl).then(response => {
      var responseParsed: IInformationPreferences = {
        insights: { email: response.data.result.insights_Email as boolean, notification: response.data.result.insights_Notification as boolean, },
        newInvoices: { email: response.data.result.newInvoices_Email as boolean, notification: response.data.result.newInvoices_Notification as boolean, },
        newsletters: { email: response.data.result.newsletters_Email as boolean, notification: response.data.result.newsletters_Notification as boolean, },
        blogs: { email: response.data.result.blogs_Email as boolean, notification: response.data.result.blogs_Notification as boolean, },
        campaigns: { email: response.data.result.campaigns_Email as boolean, notification: response.data.result.campaigns_Notification as boolean, },
        usageAlerts: { email: response.data.result.usageAlerts_Email as boolean, notification: response.data.result.usageAlerts_Notification as boolean, },
      };
      return responseParsed;
    });
}

export function updateProfileInformationPreferences(
  insights_Email: boolean, insights_Notification: boolean,
  newInvoices_Email: boolean, newInvoices_Notification: boolean,
  newsletters_Email: boolean, newsletters_Notification: boolean,
  blogs_Email: boolean, blogs_Notification: boolean,
  campaigns_Email: boolean, campaigns_Notification: boolean,
  usageAlerts_Email: boolean, usageAlerts_Notification: boolean,
) {

  return axios({
    method: 'post',
    url: UpdateProfileInformationPreferencesUrl,
    data: {
      insights_Email, insights_Notification,
      newInvoices_Email, newInvoices_Notification,
      newsletters_Email, newsletters_Notification,
      blogs_Email, blogs_Notification,
      campaigns_Email, campaigns_Notification,
      usageAlerts_Email, usageAlerts_Notification,
    }
  });
}

export function updateCompany(companyName: string, language: string, timeZoneValue: string, timeZoneText: string, country: string, website: string, phone: string, membershipType: number, imageData: string) {

  return axios({
    method: 'post',
    url: UpdateCompanyUrl,
    data: {
      'companyName': companyName,
      'language': language,
      'timeZoneValue': timeZoneValue,
      'timeZoneText': "GMT" + timeZoneText,
      'phone': phone,
      'website': website,
      'country': country,
      'membershipType': membershipType,
      'imageData': imageData,
    }
  });
}

export function getUsageAndSubcription(): Promise<UsageAndSubcriptionDto> {

  return axios({
    method: 'get',
    url: GetUsageAndSubcriptionUrl,
    data: {
    }
  }).then(response => response.data.result as UsageAndSubcriptionDto);
}

export function addFacebookIntegration(accessToken: string) {

  return axios({
    method: 'post',
    url: AddFacebookIntegrationUrl,
    data: {
      'accessToken': accessToken,
    }
  });
}

export function GetChannelList() {
  const auth = authHelper.getAuth()
  // console.log('auth', auth)
  return axios({
    method: 'get',
    url: GetChannelListUrl,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    var responseParsedList = [new ChannelFormDto]
    responseParsedList[0].id = "";
    responseParsedList.shift();
    if (response.data.result.length !== 0) {
      response.data.result.forEach((element: any) => {
        if (element !== undefined) {
          var queryArray: object[] = []
          // console.log(element.querySynonyms)
          if (element.querySynonyms !== undefined && element.querySynonyms !== null) {
            for (let i = 0; i < element.querySynonyms.length; i++) {
              queryArray.push({ "label": String(element.querySynonyms[i]), "value": String(element.querySynonyms[i]) })
            }
          }
          var queryExceptionArray: object[] = []
          if (element.queryExceptions !== undefined && element.queryExceptions !== null) {
            for (let i = 0; i < element.queryExceptions.length; i++) {
              queryExceptionArray.push({ "label": String(element.queryExceptions[i]), "value": String(element.queryExceptions[i]) })
            }
          }
          var responseParsed: ChannelFormDto = {
            channelName: element.name,
            companyId: element.companyId,
            id: element.id,
            searchQuery: element.query,
            searchQueryList: queryArray,
            searchQueryExceptionList: queryExceptionArray,
            channelCustomFieldList: element.channelCustomFieldList ?? [],
            searchUrl: element.searchUrl,
            type: element.channelType,
            isAutoSearch: element.isAutoSearch,
            isAutoAnalysis: element.isAutoAnalysis ?? true,
            expirationTime: element.expirationTime,
            token: element.token,
            tokenExpirationDate: element.tokenExpirationDate,
            dataRetrievalStartDate: element.dataRetrievalStartDate,
            language: element.language,
            isCompetitor: element.isCompetitor,
            competitorName: element.competitorName,
            isGetAccountSharings: element.isGetAccountSharings,
            isGetAccountSharingsComments: element.isGetAccountSharingsComments
          }
          responseParsedList.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function addOrUpdateChannel(Id: string, Name: string, CompanyId: string, Query: string, type: number, searchUrl: string, isAutoSearch: boolean, querySynonyms: string[], queryExceptions: string[], expirationTime: string, dataRetrievalStartDate: any, language: string, isCompetitor: boolean, competitorName: string, isGetAccountSharings: boolean, isGetAccountSharingsComments: boolean, channelCustomFieldList: { key: string; value: string }[] = [], isAutoAnalysis: boolean = true) {

  return axios({
    method: 'post',
    url: AddOrUpdateChannelUrl,
    data: {
      'Id': Id,
      'Name': Name,
      'Query': Query,
      'CompanyId': CompanyId,
      'ChannelType': type,
      'IsAutoSearch': isAutoSearch,
      'IsAutoAnalysis': isAutoAnalysis,
      "QuerySynonyms": querySynonyms,
      "QueryExceptions": queryExceptions,
      'SearchUrl': searchUrl,
      'ExpirationTime': expirationTime,
      'DataRetrievalStartDate': dataRetrievalStartDate,
      'Language': language,
      'IsCompetitor': isCompetitor,
      'CompetitorName': competitorName,
      'IsGetAccountSharings': isGetAccountSharings,
      'IsGetAccountSharingsComments': isGetAccountSharingsComments,
      'ChannelCustomFieldList': channelCustomFieldList
    }
  });
}

export function addMultiChannel(
  isTwitterOpen: boolean,
  isFacebookOpen: boolean,
  isInstagramOpen: boolean,
  isYoutubeOpen: boolean,
  isRedditOpen: boolean,
  isTikTokOpen: boolean,
  isLinkedinOpen: boolean,
  isNewsOpen: boolean,
  isSikayetvarOpen: boolean,
  isEksisozlukOpen: boolean,
  competitorName: string,
  companyId: string,
  newsQuery: string,
  searchQueryList: [],
  hashtagList: [],
  twitterUserName: string,
  facebookUserName: string,
  instagramUserName: string,
  linkedinUserName: string,
  tikTokUserName: string,
  subredditName: string,
  youtubeChannelId: string,
  // accountExceptionList: [], 
  searchUrl_Sikayetvar: string,
  searchUrl_Eksisozluk: string,
  dataRetrievalStartDate: Date,
  language: string,
  isAutoSearch: boolean,
  isCompetitor: boolean,
  isGetAccountSharings: boolean,
  isGetAccountSharingsComments: boolean
) {

  return axios({
    method: 'post',
    url: AddMultiChannelUrl,
    data: [{
      'isTwitterOpen': isTwitterOpen,
      'isInstagramOpen': isInstagramOpen,
      'isFacebookOpen': isFacebookOpen,
      'isYoutubeOpen': isYoutubeOpen,
      "isRedditOpen": isRedditOpen,
      "isTikTokOpen": isTikTokOpen,
      'isLinkedinOpen': isLinkedinOpen,
      'isNewsOpen': isNewsOpen,
      'isSikayetvarOpen': isSikayetvarOpen,
      'isEksisozlukOpen': isEksisozlukOpen,
      'CompetitorName': competitorName,
      'CompanyId': companyId,
      'NewsQuery': newsQuery,
      'SearchQueryList': searchQueryList,
      'HashtagList': hashtagList,
      'TwitterUserName': twitterUserName,
      'FacebookUserName': facebookUserName,
      'InstagramUserName': instagramUserName,
      'LinkedinUserName': linkedinUserName,
      'TikTokUserName': tikTokUserName,
      'SubredditName': subredditName,
      'YoutubeChannelId': youtubeChannelId,
      // 'AccountExceptionList': accountExceptionList,    
      'searchUrl_Sikayetvar': searchUrl_Sikayetvar,
      'searchUrl_Eksisozluk': searchUrl_Eksisozluk,
      'DataRetrievalStartDate': dataRetrievalStartDate,
      'IsAutoSearch': isAutoSearch,
      'Language': language,
      'IsCompetitor': isCompetitor,
      'IsGetAccountSharings': isGetAccountSharings,
      'IsGetAccountSharingsComments': isGetAccountSharingsComments
    }]
  });
}

export function deleteChannel(Id: string) {
  return axios({
    method: 'post',
    url: DeleteChannelUrl,
    data: {
      'Id': Id,
    }
  });
}

export function checkAndRefreshToken(token: string) {
  return axios({
    method: 'post',
    url: CheckAndRefreshTokenUrl,
    data: {
      'token': token
    }
  }).catch(function (error) {

  })
}

export function updateLanguage(language: string, reload = false) {

  axios({
    method: 'post',
    url: UpdateLanguageUrl,
    data: {
      'language': language
    }
  }).then(response => {
    if (reload === true)
      window.location.reload();
  })
}


// Server should return AuthModel
export function register(
  NameSurname: string,
  Email: string,
  Password: string,
  ConfirmPassword: string,
  CompanyName: string,
  Language: string
) {
  var offset = new Date().getTimezoneOffset();
  const timezone = offset / -60
  console.log(timezone);
  if (Language === undefined || Language === null || Language === "") { Language = navigator.language; }

  return axios.post(REGISTER_URL, {
    NameSurname: NameSurname,
    Email,
    Password,
    Confirm: ConfirmPassword,
    CompanyName,
    Timezone: timezone,
    Language
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios({
    method: 'post',
    url: REQUEST_PASSWORD_URL,
    data: {
      'email': email
    }
  });
}

export function resetPassword(c: string, password: string, confirmPassword: string) {
  return axios({
    method: 'post',
    url: ResetPasswordUrl,
    data: {
      'Password': password,
      'Code': c,
      'Confirm': confirmPassword
    }
  });
}

export function resetPasswordinProfile(password: string, newPassword: string) {
  return axios({
    method: 'post',
    url: UpdatePasswordUrl,
    data: {
      'OldPassword': password,
      'NewPassword': newPassword,
    }
  });
}

export function activateAccount(c: string) {
  return axios({
    method: 'post',
    url: ActivateAccountUrl,
    data: {
      'code': c
    }
  });
}

// Server should return AuthModel
export function activateTeamMemberAccount(
  Code: string,
  NameSurname: string,
  Email: string,
  Password: string,
  ConfirmPassword: string,
  AcceptTerms: boolean,
) {
  var offset = new Date().getTimezoneOffset();
  const timezone = offset / -60
  var userLang = navigator.language;
  return axios.post(ActivateTeamMemberAccountUrl, {
    Code,
    NameSurname,
    Email,
    Password,
    Confirm: ConfirmPassword,
    IsAggree: AcceptTerms,
    Timezone: timezone,
    Language: userLang
  })
}

export function freezeAccount(Password: string, ConfirmPassword: string) {
  return axios.post(FreezeAccountUrl, {
    Password,
    Confirm: ConfirmPassword,
  })
}

export function freezeCompany(Password: string, ConfirmPassword: string) {
  return axios.post(FreezeCompanyUrl, {
    Password,
    Confirm: ConfirmPassword,
  })
}

export function GetCompanyQuickMessages(): Promise<string[]> {
  return axios({
    method: 'get',
    url: GetCompanyQuickMessagesUrl,
  }).then((response: any) => {
    if (response?.data?.httpStatusCode === 200) {
      return response.data.result?.quickMessageList ?? []
    }
    return []
  }).catch(() => [])
}

export function UpdateCompanyQuickMessages(quickMessageList: string[]) {
  return axios({
    method: 'post',
    url: UpdateCompanyQuickMessagesUrl,
    data: { QuickMessageList: quickMessageList },
  })
}